export const assertsColors = {
  critical: '#ff5151',
  warning: '#f2c222',
  info: '#6cacfd',
};

export const baseUrl = process.env.REACT_APP_BASE_API_URL;

export const authorityUrl = process.env.REACT_APP_AUTHORITY_URL;
export const authClientId = process.env.REACT_APP_AUTH_CLIENT_ID;
export const impersonationScope = process.env.REACT_APP_AUTH_IMPERSONATION_SCOPE;




// console.log(process.env);
// debugger;

export enum ConfirmationBtnText {
  YES = 'YES',
  NO = 'NO',
  CANCEL = 'CANCEL',
  OK = 'OK',
}
